import { Col, Row } from "antd";
import React from "react";
interface OrphanAvatarProps {
  title: string;
  urlImage: string;
  className?: string;
  styleTitle?: string;
  beneficiaryNumber: string;
  beneficiaryName?: string;
  type?: string;
}
const OrphanAvatar = ({
  beneficiaryNumber,
  title,
  urlImage,
  className,
  styleTitle,
  beneficiaryName,
  type,
}: OrphanAvatarProps) => {
  return (
    <Row>
      <Col xxl={9} xl={9} lg={10} md={10} sm={10} xs={10} style={{ zIndex: 1 }}>
        <div
          className={`takaful--sponsor-orphan-card-image-content ${className}`}
        >
          <img src={urlImage} alt="" />
        </div>
      </Col>
      <Col xxl={12} xl={15} lg={14} md={12} sm={14} xs={14}>
        <div
          className={`takaful--sponsor-orphan-card-image-title ${styleTitle}`}
          style={{ marginRight: "-0.8rem", padding: "0.2rem 1.8rem" }}
        >
          <span>{title} </span>
        </div>
        {type === "unsponsored" ? (
          <div
            className=""
            style={{ display: "flex", flexDirection: "column" }}
          >
            <span className="takaful--avatar-number">{beneficiaryNumber}</span>
            <span
              className="takaful--avatar-number"
              style={{ marginTop: "-0.3rem" }}
            >
              {beneficiaryName}
            </span>
          </div>
        ) : (
          <span className="takaful--avatar-number">{beneficiaryNumber}</span>
        )}
      </Col>
    </Row>
  );
};

export default OrphanAvatar;
